<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @reload="getData"
    >
      <div class="side-frame-warning" slot="header">
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.order_tab_group_order_package_doc') || '包装文档' }}
        </span>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main'
export default {
  components: { Main },
  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .pendingOrderGoodsPackageDocListApi({ orderCode: this.orderCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
